/** @format */

import type { FormikValues } from "formik";
import type React from "react";
import type { FC } from "react";
import { cn } from "../../../util/classNameConstructor";
import type { InputProps } from "../../core/inputs/Input";
import { Input } from "../../core/inputs/Input";

export interface FormProps extends React.HTMLAttributes<HTMLFormElement> {
  inputItems?: Array<
    Omit<InputProps, "value"> & {
      value?: InputProps["value"];
    }
  >;
  formik?: FormikValues;
  outsideClick?: boolean;
  classNames?: {
    input?: string;
  };
}

const Form: FC<FormProps> = ({
  formik,
  inputItems,
  className,
  classNames,
  ...props
}) => (
  <form
    onSubmit={(e) => e.preventDefault()}
    className={cn("w-full flex flex-col gap-3", className)}
    {...props}
  >
    {inputItems?.map(({ className, ...itemProps }) => (
      <Input
        data-cy={`${itemProps.name}`}
        key={itemProps.name}
        {...(itemProps as InputProps)}
        id={itemProps.name}
        onChange={formik?.handleChange}
        onBlur={formik?.handleBlur}
        value={itemProps.name && formik?.values[itemProps.name]}
        error={
          itemProps.error ||
          (itemProps.name &&
            formik?.touched[itemProps.name] &&
            formik?.errors[itemProps.name])
        }
        classNames={{
          input: cn(classNames?.input, className),
        }}
      />
    ))}
  </form>
);

export default Form;
